module.exports = __webpack_public_path__ + "static/img/sebastian_pictgrid40_960x868.6db3c60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sebastian_pictgrid40_960x868.jpg
// module id = DeN4
// module chunks = 0